import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'scColorText',
})
export class ColorTextPipe implements PipeTransform {
  transform(text: string, phrase: string, color: string, link?: string): string {
    if (!text || !phrase || !color) return text;

    const regex = new RegExp(`(${phrase})`, 'gi');
    const tag = link ? 'a' : 'span';
    const attrs = link ? `href="${link}" target="_blank" rel="noopener"` : '';

    return text.replace(regex, `<${tag} ${attrs} class="text-${color} underline">$1</${tag}>`);
  }
}
